export enum EmbedType {
  RESTAURANT = 'RESTAURANT',
  LOCATION = 'LOCATION'
}
